// tabAjax

bq.tabAjax = function(element, options) {
  this.options   = options;
  this.$element  = $(element);
  this.handle = false;
};

bq.tabAjax.DEFAULTS = {
  changeEvent: 'show.bs.tab',
  loadInit: false
};

bq.tabAjax.prototype = {

  init: function(opt) {
    bq.debug.log("tabAjax : init()", this.$element);

    this.$element.on(this.options.changeEvent, {thiz:this}, this._catchChangeEvent);

    if(this.options.loadInit) {
      var target = this.$element.find('li.active a');
      var container = target.attr('href');
      if(target.data('target')) { container = target.data('target'); }
      this._loadData(target.data('url'), target, container);
    }
  },

  _loadData: function(url, target, container) {

    var $this = this;

    this._throwEventLoadStart();

    $(container).load(url, function(){
          target.data('loaded', true);
          $this._throwEventLoadEnd();
       });
  },

  _catchChangeEvent: function(e) {
    var $this = e.data.thiz;
    var target = $(e.target);

    if(target.data('loaded')) { return; } //already loaded the content, nothing to do
    if(target.data('url')) {
      //we have a URL, lets load it
      var container = target.attr('href');
      if(target.data('target')) { container = target.data('target'); }
      $this._loadData(target.data('url'), target, container);
    }

  },

  _throwEventLoadStart: function() {
    bq.debug.log("tabAjax : event thrown [bq.tabajax.loadStart]");
    this.$element.trigger('bq.tabajax.loadStart', this);
  },

  _throwEventLoadEnd: function() {
    bq.debug.log("tabAjax : event thrown [bq.tabajax.loadEnd]");
    this.$element.trigger('bq.tabajax.loadEnd', this);
  }


};


// tabAjax PLUGIN DEFINITION
// =======================

var tabAjaxold = $.fn.tabAjax;

$.fn.tabAjax = function (option, _relatedTarget) {
  return this.each(function () {
    var $this   = $(this);
    var data    = $this.data('bq.tabAjax');
    var options = $.extend({}, bq.tabAjax.DEFAULTS, $this.data(), typeof(option) === 'object' && option);

    if (!data) { $this.data('bq.tabAjax', (data = new bq.tabAjax(this, options))); }
    data.init();
  });
};

$.fn.tabAjax.Constructor = bq.tabAjax;

// tabAjax NO CONFLICT
// =================

$.fn.tabAjax.noConflict = function () {
  $.fn.tabAjax = tabAjaxold;
  return this;
};

// tabAjax DATA-API
// ==============

bq.tabAjaxInit = function() {
  $('[data-bq="tabajax"]').each(function () {
    var el = $(this);
    if(el.data('bq.tabAjax')) { return; }
    el.tabAjax(el.data());
  });
};

bq.init.push(bq.tabAjaxInit);
